<template>
  <div>
    <mdb-container>
    <h2 class="h1-responsive font-weight-bold text-center my-4 customTitle">Recent posts</h2>
    <p class="text-center w-responsive mx-auto mb-4 customBody">
      <vue-typed-js :strings="['Here you will find a collection of relevant articles regarding technology. Read on for the latest in technological advancements and relevant news regarding the tech space.']">
        <span class="typing"></span>
      </vue-typed-js>
    </p>
    <div v-for="post in posts" :key="post.id" class="z-depth-2">
      <mdb-row class="p-5">
        <mdb-col lg="10" xl="11">
          <h3 class="font-weight-bold mb-3 p-0">
            <strong class=" p-2 m-1 customTitle">
              {{post.title}}
            </strong>
          </h3>
          <p class="customBody" v-html="post.body">
          </p>
          <p class="customFooter">by
            <a class="font-weight-bold">@hypertech</a>, {{post.createdAt.toDate().toLocaleDateString( "en-US",{weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'})}}</p>
        </mdb-col>
        <mdb-col v-if="flag">
          <button  @click="deletePost(post)" class="z-depth-2 hoverable p-1 text-center button">
             <mdb-icon icon="trash-alt" class="red-text padding" />
          </button>
          <button class="z-depth-2 hoverable p-1 text-center button">
             <mdb-icon icon="edit" class="blue-text padding" />
          </button>
        </mdb-col>
      </mdb-row>
      <hr class="my-5" />
    </div>
  </mdb-container>
  </div>
</template>

<script>
import { postsCollection } from '@/firebase'
import mdbIcon from 'mdbvue/lib/components/mdbIcon'
import mdbContainer from 'mdbvue/lib/components/mdbContainer'
import mdbRow from 'mdbvue/lib/components/mdbRow'
import mdbCol from 'mdbvue/lib/components/mdbCol'

import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  name: 'Blog',
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbIcon
  },
  data () {
    return {
      posts: []
    }
  },
  firestore () {
    return {
      posts: postsCollection.orderBy('createdAt', 'desc')
    }
  },
  methods: {
    isSignedIn () {
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          this.flag = true
        } else {
          this.flag = false
        }
      })
    },
    deletePost (post) {
      postsCollection.doc(post.id).delete()
    }
  },
  mounted () {
    this.isSignedIn()
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Montserrat&display=swap');
@import url('https://fonts.googleapis.com/css?family=Zilla+Slab&display=swap');
@import url('https://fonts.googleapis.com/css?family=Josefin+Sans&display=swap');
.padding{
  padding: 10px;
}
.button {
  background-color: rgb(243, 237, 237);
  border: none;
  color: white;
  padding: 50px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 15px;
  margin: 4px 2px;
  border-radius: 50%;
}
.customTitle{
font-family: 'Josefin Sans', sans-serif;
}
.customBody{
  font-family: 'Montserrat', sans-serif;
}
.customFooter{
  font-family: 'Zilla Slab', serif;
  font-size: 20px;
}
</style>
